/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemDropdownParameterDefinitionResponse } from './SystemDropdownParameterDefinitionResponse';
import {
    SystemDropdownParameterDefinitionResponseFromJSON,
    SystemDropdownParameterDefinitionResponseFromJSONTyped,
    SystemDropdownParameterDefinitionResponseToJSON,
    SystemDropdownParameterDefinitionResponseToJSONTyped,
} from './SystemDropdownParameterDefinitionResponse';
import type { SystemDropdownCategory } from './SystemDropdownCategory';
import {
    SystemDropdownCategoryFromJSON,
    SystemDropdownCategoryFromJSONTyped,
    SystemDropdownCategoryToJSON,
    SystemDropdownCategoryToJSONTyped,
} from './SystemDropdownCategory';

/**
 * 
 * @export
 * @interface SystemDropdownCategoryResponse
 */
export interface SystemDropdownCategoryResponse {
    /**
     * 
     * @type {SystemDropdownCategory}
     * @memberof SystemDropdownCategoryResponse
     */
    category: SystemDropdownCategory;
    /**
     * 
     * @type {number}
     * @memberof SystemDropdownCategoryResponse
     */
    maxValueLength: number;
    /**
     * 
     * @type {Array<SystemDropdownParameterDefinitionResponse>}
     * @memberof SystemDropdownCategoryResponse
     */
    parameters: Array<SystemDropdownParameterDefinitionResponse>;
}



/**
 * Check if a given object implements the SystemDropdownCategoryResponse interface.
 */
export function instanceOfSystemDropdownCategoryResponse(value: object): value is SystemDropdownCategoryResponse {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('maxValueLength' in value) || value['maxValueLength'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    return true;
}

export function SystemDropdownCategoryResponseFromJSON(json: any): SystemDropdownCategoryResponse {
    return SystemDropdownCategoryResponseFromJSONTyped(json, false);
}

export function SystemDropdownCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemDropdownCategoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'category': SystemDropdownCategoryFromJSON(json['category']),
        'maxValueLength': json['maxValueLength'],
        'parameters': ((json['parameters'] as Array<any>).map(SystemDropdownParameterDefinitionResponseFromJSON)),
    };
}

export function SystemDropdownCategoryResponseToJSON(json: any): SystemDropdownCategoryResponse {
    return SystemDropdownCategoryResponseToJSONTyped(json, false);
}

export function SystemDropdownCategoryResponseToJSONTyped(value?: SystemDropdownCategoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': SystemDropdownCategoryToJSON(value['category']),
        'maxValueLength': value['maxValueLength'],
        'parameters': ((value['parameters'] as Array<any>).map(SystemDropdownParameterDefinitionResponseToJSON)),
    };
}

